module.exports = __webpack_public_path__ + "img/logo_fullName_white.26728868.svg";